import * as React from "react";
import './modal.scss';
import {Container} from "../../grid/container";

/**
 const closeIcon = '/assets/src/components/layouts/close.svg';
 const logoSvg = '/assets/src/components/layouts/iaom_nop.png';
 */
const close: string = '/assets/src/components/libs/modal/close.svg';

export class ModalComponent extends React.Component<any, any> {
    public ref: HTMLElement;

    public state: any = {
        opened: false,
    };

    public openModal() {
        this.setState({opened: true});
    }

    public closeModal() {
        this.setState({opened: false})
    }

    public render() {
        return <div
            className={`modalComponent ${this.state.opened ? 'opened' : ''} ${(!this.state.status && this.state.colored) ? 'colored' : ''}`}
            ref={(ref: any) => { this.ref = ref; }}>
            <div className={`modalWrapper animated ${this.state.opened ? 'fadeInRight' : 'fadeOutRight'}`}>
                <Container disableScrollEvent={true}>
                    {this.props.children}
                </Container>
                <div className='modal-close' onClick={() => this.closeModal()}>
                    <img src={close} alt=""/>
                </div>
            </div>


        </div>;
    }
}

